<template>
	<div class="landing-home" v-if="pageHome.elements">
		<!-- content home -->
		<hero :props="pageHome.elements"  :heroHome="true"></hero>
		<section class="content-works" id="section">
			<div class="inside">
				<p class="intro_text" v-in-viewport="{}" v-if="pageHome.elements.intro_paragraph">{{pageHome.elements.intro_paragraph.value}}</p>
				<boxes-wrapper :boxes="works" :modularContent="modularContent" :boxlimit="4" :showViewAll="false"></boxes-wrapper>
			</div>
		</section>
		<section class="content-articles" v-in-viewport="">
			<div class="inside">
				<h2 class="text-center" v-in-viewport="">Insights, commentary and news</h2>
				<p class="text-center container" v-if="pageHome.elements.related_words_description">{{pageHome.elements.related_words_description.value}}</p>
				<articles-wrapper :boxes="words" :isHome="true" :boxlimit="4" :pathRoute="'/words'" :showViewAll="true" :showCategory="true"></articles-wrapper>
			</div>
		</section>
	</div>
</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import boxesWrapper from '../components/boxes-wrapper.vue';
	import articlesWrapper from '../components/articles-wrapper.vue';
	import hero from '../components/hero.vue';
	var objectFitImages = require('object-fit-images');

	export default{
		name:'Home',
		data () {
		   return {
		   	 pageHome: [],
		     works: [],
		     words:[],
		     modularContent:[]
		   }
		 },
		created:function(){
			this.getHome();
		},
		mounted: function() {
			setTimeout(function(){
			    $('.st-sticky-share-buttons').removeClass('st-sticky-share-buttons-show')
			},500);

		},
		components:{
			'boxes-wrapper':boxesWrapper,
			'articles-wrapper':articlesWrapper,
			'hero':hero
		},
		mixins:[apiConnection,seoModule]
	}
</script>



// WEBPACK FOOTER //
// Home.vue?f9bfce3e